import { render } from "./CourseCategoriesPage.vue?vue&type=template&id=d905e0c2&scoped=true"
import script from "./CourseCategoriesPage.vue?vue&type=script&lang=js"
export * from "./CourseCategoriesPage.vue?vue&type=script&lang=js"

import "./CourseCategoriesPage.vue?vue&type=style&index=0&id=d905e0c2&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d905e0c2"]])

export default __exports__